(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bank-details-verification"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async function (event) {
    const copyButton = event.target.closest('[data-copy-value]');
    if (copyButton) {
      const value = copyButton.dataset.copyValue;
      const section = copyButton.closest('.bank-verification');
      const status = section ? section.querySelector('.bank-verification__copy-status') : null;
      try {
        await navigator.clipboard.writeText(value);
        copyButton.classList.add('is-copied');
        copyButton.textContent = 'Copied ✓';
        if (status) status.textContent = value + ' copied to clipboard.';
        window.setTimeout(function () {
          copyButton.classList.remove('is-copied');
          copyButton.textContent = 'Copy';
          if (status) status.textContent = '';
        }, 2200);
      } catch (error) {
        if (status) status.textContent = 'Copying was unavailable. Please select the details manually.';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["create-a-quote"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('.se-quote').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const selected=new Map(),input=root.querySelector('input[type=search]'),results=root.querySelector('.se-quote__results'),state=root.querySelector('.se-quote__state'),dialog=root.querySelector('dialog');let timer,controller,lastProducts=[],quoteMeta=null;const money=c=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format((Number(c)||0)/100),esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c])),toast=m=>{document.querySelector('.se-quote__toast')?.remove();const e=document.createElement('div');e.className='se-quote__toast';e.textContent=m;Object.assign(e.style,{position:'fixed',right:'22px',bottom:'22px',zIndex:9999,padding:'14px 18px',borderRadius:'10px',background:'#07172f',color:'#fff',fontWeight:700});document.body.appendChild(e);setTimeout(()=>e.remove(),3200)},items=()=>[...selected.values()],subtotal=()=>items().reduce((s,i)=>s+i.price*i.quantity,0),details=()=>Object.fromEntries([...root.querySelectorAll('[data-field]')].map(e=>[e.dataset.field,e.value.trim()])),quoteNumber=()=>`SE-Q-${new Date().toISOString().slice(2,10).replaceAll('-','')}-${Math.random().toString(36).slice(2,6).toUpperCase()}`;
const serialise=()=>({version:1,details:details(),items:items(),quote:quoteMeta});function render(){const list=root.querySelector('.se-quote__selected'),empty=root.querySelector('.se-quote__empty'),totals=root.querySelector('.se-quote__totals'),all=items(),units=all.reduce((s,i)=>s+i.quantity,0);root.querySelector('[data-count]').textContent=`${units} item${units===1?'':'s'}`;root.querySelector('[data-units]').textContent=units;root.querySelector('[data-subtotal]').textContent=money(subtotal());empty.hidden=!!all.length;list.hidden=!all.length;totals.hidden=!all.length;list.innerHTML=all.map(i=>`<article class="se-quote__selected-item" data-id="${i.id}"><div><h3>${esc(i.productTitle)}</h3><p>${esc(i.variantTitle)} · SKU ${esc(i.sku||'—')}</p><div class="se-quote__selected-controls"><button data-minus aria-label="Decrease">−</button><strong>${i.quantity}</strong><button data-plus aria-label="Increase">+</button><button data-remove>Remove</button></div></div><strong>${money(i.price*i.quantity)}</strong></article>`).join('');list.querySelectorAll('article').forEach(row=>{const i=selected.get(Number(row.dataset.id));row.querySelector('[data-minus]').onclick=()=>{i.quantity=Math.max(1,i.quantity-1);render()};row.querySelector('[data-plus]').onclick=()=>{i.quantity++;render()};row.querySelector('[data-remove]').onclick=()=>{selected.delete(i.id);render();renderResults(lastProducts)}})}
function renderResults(products){lastProducts=products;state.hidden=true;results.hidden=false;results.innerHTML=`<div class="se-quote__results-head"><span>Product</span><span>Option</span><span>Quantity</span><span>Add</span></div>`+products.map((p,x)=>{const vs=p.variants.filter(v=>v.available);if(!vs.length)return'';const v=vs[0],single=vs.length===1&&v.title==='Default Title';return`<article class="se-quote__row${single?' is-single':''}" data-index="${x}"><div class="se-quote__product"><img src="${esc(p.featured_image||p.images?.[0]||'')}" alt="" loading="lazy"><div><h3><a href="${esc(p.url)}">${esc(p.title)}</a></h3><div class="se-quote__meta"><span>SKU: <b data-sku>${esc(v.sku||'—')}</b></span><span class="se-quote__stock">In stock</span></div><div class="se-quote__price">${money(v.price)}</div></div></div><div class="se-quote__variant"><select aria-label="Option for ${esc(p.title)}">${vs.map(o=>`<option value="${o.id}" data-price="${o.price}" data-sku="${esc(o.sku||'')}">${esc(o.title==='Default Title'?'Standard option':o.title)} — ${money(o.price)}</option>`).join('')}</select></div><div class="se-quote__qty"><button data-step="-1">−</button><input type="number" min="1" value="1" aria-label="Quantity"><button data-step="1">+</button></div><button class="se-quote__add">Add to quote</button></article>`}).join('');results.querySelectorAll('.se-quote__row').forEach(row=>{const p=products[Number(row.dataset.index)],select=row.querySelector('select'),qty=row.querySelector('.se-quote__qty input'),add=row.querySelector('.se-quote__add');row.querySelectorAll('[data-step]').forEach(b=>b.onclick=()=>qty.value=Math.max(1,(parseInt(qty.value)||1)+Number(b.dataset.step)));select.onchange=()=>{const o=select.selectedOptions[0];row.querySelector('[data-sku]').textContent=o.dataset.sku||'—';row.querySelector('.se-quote__price').textContent=money(o.dataset.price);add.classList.remove('is-selected');add.textContent='Add to quote'};add.onclick=()=>{const o=select.selectedOptions[0],v=p.variants.find(v=>String(v.id)===select.value),id=Number(select.value);selected.set(id,{id,quantity:Math.max(1,parseInt(qty.value)||1),price:Number(o.dataset.price),sku:o.dataset.sku,productTitle:p.title,variantTitle:v.title==='Default Title'?'Standard option':v.title});add.classList.add('is-selected');add.textContent='Selected ✓';render();toast(`${p.title} added to quote`)}})}
async function search(q){controller?.abort();controller=new AbortController();state.hidden=false;state.innerHTML='<div class="se-quote__notice">Searching products…</div>';results.hidden=true;try{const base=window.Shopify?.routes?.root||'/',r=await fetch(`${base}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.sku,variants.title,product_type,vendor`,{signal:controller.signal,headers:{Accept:'application/json'}});if(!r.ok)throw Error();const found=(await r.json())?.resources?.results?.products||[],products=(await Promise.all(found.map(async p=>{try{return await fetch(p.url.split('?')[0]+'.js',{signal:controller.signal}).then(r=>r.json())}catch{return null}}))).filter(p=>p?.variants?.some(v=>v.available)),low=q.toLowerCase();products.sort((a,b)=>Math.max(...b.variants.map(v=>String(v.sku||'').toLowerCase()===low?3:String(v.sku||'').toLowerCase().includes(low)?2:b.title.toLowerCase().includes(low)?1:0))-Math.max(...a.variants.map(v=>String(v.sku||'').toLowerCase()===low?3:String(v.sku||'').toLowerCase().includes(low)?2:a.title.toLowerCase().includes(low)?1:0)));if(!products.length){state.innerHTML='<div class="se-quote__notice">No available products found. Try another name or product code.</div>';return}renderResults(products)}catch(e){if(e.name!=='AbortError')state.innerHTML='<div class="se-quote__notice">Search is temporarily unavailable. Please try again.</div>'}}
input.oninput=()=>{const q=input.value.trim();root.querySelector('[data-clear]').hidden=!q;clearTimeout(timer);if(q.length<2){results.hidden=true;state.hidden=false;return}timer=setTimeout(()=>search(q),280)};input.onkeydown=e=>{if(e.key==='Enter'&&input.value.trim().length>=2){e.preventDefault();clearTimeout(timer);search(input.value.trim())}};root.querySelector('[data-clear]').onclick=()=>{input.value='';input.dispatchEvent(new Event('input'));input.focus()};
function validate(){const d=details(),missing=['organisation','contact','email','address'].filter(k=>!d[k]);if(missing.length){root.querySelector(`[data-field=${missing[0]}]`).focus();toast('Please complete the required organisation details');return false}if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)){root.querySelector('[data-field=email]').focus();toast('Please enter a valid email address');return false}if(!selected.size){toast('Add at least one product to generate a quote');return false}return true}
function prepare(){if(!validate())return false;const created=new Date(),expires=new Date(created);expires.setDate(expires.getDate()+14);quoteMeta={number:quoteMeta?.number||quoteNumber(),created:created.toISOString(),expires:expires.toISOString()};const d=details(),date=v=>new Intl.DateTimeFormat('en-GB',{day:'2-digit',month:'long',year:'numeric'}).format(new Date(v));root.querySelectorAll('[data-print-number]').forEach(e=>e.textContent=quoteMeta.number);root.querySelector('[data-print-date]').textContent=date(quoteMeta.created);root.querySelector('[data-print-expiry]').textContent=date(quoteMeta.expires);root.querySelector('[data-print-org]').textContent=d.organisation;root.querySelector('[data-print-address]').textContent=d.address;root.querySelector('[data-print-contact]').textContent=`${d.contact} · ${d.email}${d.phone?' · '+d.phone:''}`;root.querySelector('[data-print-reference]').textContent=d.reference||'—';root.querySelector('[data-print-lines]').innerHTML=items().map(i=>`<tr><td>${esc(i.productTitle)}</td><td>${esc(i.sku||'—')}</td><td>${esc(i.variantTitle)}</td><td>${i.quantity}</td><td>${money(i.price)}</td><td>${money(i.price*i.quantity)}</td></tr>`).join('');root.querySelector('[data-print-total]').textContent=money(subtotal());root.querySelector('[data-dialog-title]').textContent=`Quotation ${quoteMeta.number}`;localStorage.setItem('seQuoteDraft',JSON.stringify(serialise()));return true}
function share(){if(!prepare())return;const encoded=btoa(unescape(encodeURIComponent(JSON.stringify(serialise())))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');const url=`${location.origin}${location.pathname}#quote=${encoded}`;navigator.clipboard?.writeText(url).then(()=>toast('Shareable quotation link copied')).catch(()=>window.prompt('Copy this quotation link:',url))}
function load(data){if(!data?.items)return;(data.items||[]).forEach(i=>selected.set(Number(i.id),{...i,id:Number(i.id),quantity:Math.max(1,Number(i.quantity)||1),price:Number(i.price)||0}));Object.entries(data.details||{}).forEach(([k,v])=>{const e=root.querySelector(`[data-field=${k}]`);if(e)e.value=v});quoteMeta=data.quote||null;render();toast('Saved quotation loaded')}
root.querySelector('[data-generate]').onclick=()=>{if(prepare())dialog.showModal()};root.querySelector('[data-close]').onclick=()=>dialog.close();root.querySelector('[data-save]').onclick=()=>{localStorage.setItem('seQuoteDraft',JSON.stringify(serialise()));toast('Draft quotation saved in this browser')};root.querySelector('[data-share]').onclick=share;root.querySelector('[data-dialog-share]').onclick=share;root.querySelector('[data-clear-quote]').onclick=()=>{if(!confirm('Clear all products and organisation details?'))return;selected.clear();root.querySelectorAll('[data-field]').forEach(e=>{if(e.tagName!=='SELECT')e.value=''});quoteMeta=null;localStorage.removeItem('seQuoteDraft');render();toast('Quotation cleared')};root.querySelector('[data-print]').onclick=()=>{if(prepare())window.print()};root.querySelector('[data-excel]').onclick=()=>{if(!prepare())return;const d=details(),q=v=>'"'+String(v??'').replace(/"/g,'""')+'"',rows=[['Sensory Education quotation',quoteMeta.number],['Organisation',d.organisation],['Contact',d.contact],['Email',d.email],['Address',d.address],['Valid for','14 days'],[],['Product','SKU','Option','Quantity','Unit price','Line total'],...items().map(i=>[i.productTitle,i.sku,i.variantTitle,i.quantity,(i.price/100).toFixed(2),((i.price*i.quantity)/100).toFixed(2)]),[],['Estimated total','','','','',(subtotal()/100).toFixed(2)],['Important','Prices, availability and delivery charges may change when the order is placed.']],csv='\ufeff'+rows.map(r=>r.map(q).join(',')).join('\r\n'),url=URL.createObjectURL(new Blob([csv],{type:'text/csv;charset=utf-8'})),a=document.createElement('a');a.href=url;a.download=`sensory-education-${quoteMeta.number}.csv`;a.click();URL.revokeObjectURL(url)};root.querySelector('[data-order]').onclick=async()=>{if(!prepare())return;const button=root.querySelector('[data-order]');button.disabled=true;button.textContent='Creating basket…';try{const r=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items().map(i=>({id:i.id,quantity:i.quantity}))})});if(!r.ok)throw Error();await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note:`Quotation ${quoteMeta.number}${details().reference?' · Customer reference: '+details().reference:''}`})});location.href=(window.Shopify?.routes?.root||'/')+'cart'}catch{toast('We could not create the basket. Please try again.');button.disabled=false;button.textContent='Convert to order'}};
try{if(location.hash.startsWith('#quote=')){let s=location.hash.slice(7).replace(/-/g,'+').replace(/_/g,'/');while(s.length%4)s+='=';load(JSON.parse(decodeURIComponent(escape(atob(s)))))}else{const saved=JSON.parse(localStorage.getItem('seQuoteDraft')||'null');if(saved?.items?.length)load(saved)}}catch{}render()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.keepOpen();
        window.addEventListener('resizeend', this.keepOpen.bind(this));

        if (this.summaryElem) {
          this.summaryElem.addEventListener('click', (event) => {
            event.preventDefault();
            this.keepOpen();
          });
        }
      }

      keepOpen() {
        if (this.detailsElem) {
          this.detailsElem.open = true;
        }

        if (this.summaryElem) {
          this.summaryElem.setAttribute('aria-expanded', 'true');
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["present-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const finders = document.querySelectorAll('[data-present-finder]');

    finders.forEach((finder) => {
      if (finder.dataset.initialized === 'true') return;
      finder.dataset.initialized = 'true';

      const form = finder.querySelector('[data-finder-form]');
      const steps = [...finder.querySelectorAll('[data-step]')];
      const progress = [...finder.querySelectorAll('[data-progress-step]')];
      const results = finder.querySelector('[data-results]');
      const status = finder.querySelector('[data-results-status]');
      const grid = finder.querySelector('[data-product-grid]');
      const viewAll = finder.querySelector('[data-view-all]');
      let currentStep = 1;

      const showStep = (stepNumber) => {
        currentStep = stepNumber;
        steps.forEach((step) => {
          step.hidden = Number(step.dataset.step) !== currentStep;
        });
        progress.forEach((item) => {
          const itemStep = Number(item.dataset.progressStep);
          item.classList.toggle('is-active', itemStep === currentStep);
          item.classList.toggle('is-complete', itemStep < currentStep);
        });
        const legend = steps[currentStep - 1].querySelector('legend');
        if (legend) legend.focus({ preventScroll: true });
      };

      const selectedTypes = () => [...form.querySelectorAll('input[name="gift_type"]:checked')];

      form.querySelectorAll('input[name="gift_type"]').forEach((input) => {
        input.addEventListener('change', () => {
          if (selectedTypes().length > 3) {
            input.checked = false;
            const error = input.closest('fieldset').querySelector('[data-error]');
            error.textContent = finder.dataset.maximumMessage;
          } else {
            input.closest('fieldset').querySelector('[data-error]').textContent = '';
          }
        });
      });

      const validateStep = () => {
        const step = steps[currentStep - 1];
        const error = step.querySelector('[data-error]');
        let valid = true;

        if (currentStep === 1) valid = Boolean(form.querySelector('input[name="gift_age"]:checked'));
        if (currentStep === 2) valid = selectedTypes().length > 0;
        if (currentStep === 3) valid = Boolean(form.querySelector('input[name="gift_budget"]:checked'));

        error.textContent = valid ? '' : finder.dataset.requiredMessage;
        return valid;
      };

      form.querySelectorAll('[data-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (validateStep()) showStep(Math.min(currentStep + 1, 3));
        });
      });

      form.querySelectorAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => showStep(Math.max(currentStep - 1, 1)));
      });

      const normaliseImage = (image) => {
        if (!image) return '';
        if (typeof image === 'string') return image.startsWith('//') ? `https:${image}` : image;
        return image.url || image.src || '';
      };

      const numericPrice = (price) => {
        const value = String(price || '').replace(/[^0-9.]/g, '');
        return Number.parseFloat(value);
      };

      const productCard = (product) => {
        const link = document.createElement('a');
        link.className = 'present-finder__product-card';
        link.href = product.url;

        const imageUrl = normaliseImage(product.image || product.featured_image);
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.title || '';
          image.loading = 'lazy';
          image.width = 320;
          image.height = 320;
          link.appendChild(image);
        }

        const copy = document.createElement('span');
        copy.className = 'present-finder__product-copy';

        const title = document.createElement('strong');
        title.textContent = product.title || '';
        copy.appendChild(title);

        if (product.price) {
          const price = document.createElement('span');
          price.className = 'present-finder__price';
          price.textContent = product.price;
          copy.appendChild(price);
        }

        link.appendChild(copy);
        return link;
      };

      const fetchProducts = async (query) => {
        const url = new URL(finder.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product search failed');
        const data = await response.json();
        return data.resources?.results?.products || [];
      };

      const buildSearchUrl = (queries, budget) => {
        const url = new URL(finder.dataset.searchUrl, window.location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('q', queries.join(' '));
        if (budget.dataset.min) url.searchParams.set('filter.v.price.gte', budget.dataset.min);
        if (budget.dataset.max) url.searchParams.set('filter.v.price.lte', budget.dataset.max);
        return `${url.pathname}${url.search}`;
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!validateStep()) return;

        const age = form.querySelector('input[name="gift_age"]:checked');
        const budget = form.querySelector('input[name="gift_budget"]:checked');
        const types = selectedTypes();
        const ageQuery = age.dataset.query;
        const queries = types.map((input) => input.value);

        form.hidden = true;
        finder.querySelector('.present-finder__progress').hidden = true;
        results.hidden = false;
        results.setAttribute('aria-busy', 'true');
        status.textContent = finder.dataset.loadingMessage;
        grid.replaceChildren();
        viewAll.href = buildSearchUrl([...queries, ageQuery], budget);

        try {
          const batches = await Promise.all(
            queries.map(async (query) => {
              let products = await fetchProducts(`${query} ${ageQuery}`);
              if (products.length === 0) products = await fetchProducts(query);
              return products;
            })
          );

          const products = [];
          const seen = new Set();
          batches.flat().forEach((product) => {
            if (!product.url || seen.has(product.url)) return;
            const price = numericPrice(product.price);
            const minimum = Number.parseFloat(budget.dataset.min || '0');
            const maximum = budget.dataset.max ? Number.parseFloat(budget.dataset.max) : Number.POSITIVE_INFINITY;
            if (Number.isFinite(price) && (price < minimum || price > maximum)) return;
            seen.add(product.url);
            products.push(product);
          });

          products.slice(0, 8).forEach((product) => grid.appendChild(productCard(product)));
          status.textContent = products.length ? '' : finder.dataset.noResultsMessage;
        } catch (error) {
          status.textContent = finder.dataset.noResultsMessage;
        } finally {
          results.setAttribute('aria-busy', 'false');
          results.querySelector('h2').focus({ preventScroll: true });
        }
      });

      finder.querySelector('[data-restart]').addEventListener('click', () => {
        form.reset();
        grid.replaceChildren();
        status.textContent = '';
        results.hidden = true;
        form.hidden = false;
        finder.querySelector('.present-finder__progress').hidden = false;
        showStep(1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
